import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-offerpayment',
  templateUrl: './offerpayment.component.html',
  styleUrls: ['./offerpayment.component.scss']
})
export class OfferpaymentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
